import React from 'react';
import { pivotProgramDepartmentTop5 } from '../../lib/dlpSteelTable';

interface Props {
  title: string;
  /** "첨부 건수" 또는 "차단 건수" — API 컬럼명(첨부건수/차단건수)과 별개로 화면 표시용 라벨 */
  totalCountLabel: string;
  rows: Record<string, string>[];
}

/**
 * "프로그램에 따른 부서별 첨부/차단 추이" 전용 렌더러 (IPT-441 후속 확인, 2026-09-15).
 * 프로그램별로 TOP5 부서를 "구분"/"이용량" 2행으로 가로 펼쳐 보여주는 피벗 표.
 * 임의 컬럼을 그대로 세로 나열하는 SteelReportTable로는 표현할 수 없어 전용 컴포넌트로 분리.
 */
export const SteelProgramPivotTable: React.FC<Props> = ({ title, totalCountLabel, rows }) => {
  const pivoted = pivotProgramDepartmentTop5(rows);

  return (
    <div className="steel-program-pivot-table" style={{ marginBottom: '1.5rem' }}>
      <h3>{title}</h3>
      {pivoted.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '1rem' }}>데이터가 없습니다.</div>
      ) : (
        <table className="policy-table">
          <thead>
            <tr>
              <th>프로그램명</th>
              <th>{totalCountLabel}</th>
              <th>구분</th>
              <th colSpan={5}>주요 대상 부서</th>
            </tr>
          </thead>
          <tbody>
            {pivoted.map((p) => (
              <React.Fragment key={p.program}>
                <tr>
                  <td rowSpan={2}>{p.program}</td>
                  <td rowSpan={2}>{p.totalCount}</td>
                  <td>구분</td>
                  {p.departments.map((d, i) => (
                    <td key={i}>{d ? d.name : '-'}</td>
                  ))}
                </tr>
                <tr>
                  <td>이용량</td>
                  {p.departments.map((d, i) => (
                    <td key={i}>{d ? d.count : '-'}</td>
                  ))}
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
